import {
  GET_RETURN_SUMMARY_REQUEST,
  GET_RETURN_SUMMARY_SUCCESS,
  GET_RETURN_SUMMARY_ERROR,
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getReturnSummary = (token, values) => (dispatch) => {
  dispatch({ type: GET_RETURN_SUMMARY_REQUEST });

  const newData = {
          customer_cat_id: values.cutomer_category === "All" ||  values.cutomer_category === undefined ? null : values.cutomer_category,
          date_from: moment(values.from_date).format("MM-DD-YYYY"),
          date_to: moment(values.to_date).format("MM-DD-YYYY"),
          
          note_header_no: values.note_header_no === undefined || values.note_header_no === "" ?  null : values.note_header_no,
          return_header_no: values.return_header_no === undefined || values.return_header_no === "" ?  null : values.return_header_no,
          invoice_header_no: values.invoice_header_no === undefined || values.invoice_header_no === "" ?  null : values.invoice_header_no,
          ship_header_no: values.ship_header_no === undefined || values.ship_header_no === "" ?  null : values.ship_header_no,
          ra_aproval: values.ra_aproval === undefined || values.ra_aproval === "" ?  null : values.ra_aproval,
          asn_no: values.asn_no === undefined || values.asn_no === "" ?  null : values.asn_no,
          reference_no: values.po_no === undefined || values.po_no === "" ?  null : values.po_no,
          customer: values.customer === undefined || values.customer === "" ? null : values.customer,
          bill_addressee: values.billing_addressee === undefined || values.billing_addressee === "" ? null : values.billing_addressee,
          sp_id: values.sale_person === "All" || values.sale_person === undefined ? null : values.sale_person,
          region_id: values.region === "All" || values.region === undefined  ? null : values.region,
          gender_id: values.gender === "All" || values.gender === undefined ? null : values.gender,
          payment_term_id: values.terms === "All" || values.terms === undefined ? null : values.terms,
          
          company_id: values.subsidary === "All" || values.subsidary === undefined  ? null : values.subsidary,
          
          sku: values.sku === undefined || values.sku === "" ? null : values.sku,
          
          location_id: values.location === undefined || values.location === "All" ? null : values.location,
          ntype: null,
          customer_id : values.customerNew === undefined ? null : values.customerNew
  };
  
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/omsReturn`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData,
  })
    .then((response) => {
      return dispatch({
        type: GET_RETURN_SUMMARY_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_RETURN_SUMMARY_ERROR,
        payload: [],
      });
      
      
      
      
      
      
      
      
      
      
    });
};
